import { showDeleteExamScheduleState } from '@/atoms';
import { useDeleteExamSchedule } from '@/services/exam-schedules';
import { ModalLayout } from 'moh-ui';
import { useRecoilState } from 'recoil';
import { Button, Group } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useQueryClient } from '@tanstack/react-query';
import useAuth from '@/hooks/useAuth';

export default function DeleteExamScheduleModal() {
    const [show, setShow] = useRecoilState(showDeleteExamScheduleState);
    const { user } = useAuth();
    const queryClient = useQueryClient();
    const {
        mutate: deleteExamSchedule,
        isPending: deletingExamSchedule
    } = useDeleteExamSchedule();

    function handleDelete() {
        if (!show?.examSchedule) return;
        
        console.log('Deleting exam schedule:', show.examSchedule.id);
        
        deleteExamSchedule(show.examSchedule.id, {
            onSuccess: (response) => {
                console.log('Delete success:', response);
                notifications.show({
                    title: 'Success',
                    message: 'Exam schedule deleted successfully',
                    color: 'green',
                });
                queryClient.invalidateQueries({ queryKey: ['exam-schedules'] });
                setShow(null);
            },
            onError: (error) => {
                console.error('Delete error:', error);
                notifications.show({
                    title: 'Error',
                    message: error.response?.data?.message || 'Failed to delete exam schedule',
                    color: 'red',
                });
            },
        });
    }

    return (
        <ModalLayout
            open={Boolean(show?.show)}
            onClose={() => setShow(null)}
            title="Delete Exam Schedule"
        >
            <div>Are you sure you want to delete this exam schedule?</div>
            <div className="my-2 font-semibold">{show?.examSchedule?.title}</div>
            <Group justify="right" mt="md">
                <Button variant="outline" onClick={() => setShow(null)} disabled={deletingExamSchedule}>Cancel</Button>
                <Button color="red" loading={deletingExamSchedule} onClick={handleDelete}>Delete</Button>
            </Group>
        </ModalLayout>
    )
}
